export enum AppTheme {
    white = 'light',
    dark = 'dark',
    xdesign = 'xdesign',
}
